import { getParameterByName, validatePesel } from './utils';
import myConfig from './config.vue';
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import VueMoment from 'vue-moment';
import VueResource from 'vue-resource';
import VueTabs from 'vue-nav-tabs';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import { routes } from './routes';
import store from './store/store';
import dictionary from './data/dictionary';
import VeeValidate, { Validator } from 'vee-validate';
import * as VueGoogleMaps from 'vue2-google-maps';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale';
import VueScrollTo from 'vue-scrollto';
import vueCalendar from './components/shared/vue-calendar/calendar.vue';
import vueVimeoPlayer from 'vue-vimeo-player';
import VueCookie from 'vue-cookie';
import AsyncComputed from 'vue-async-computed';
import 'babel-polyfill';
import './plugins/customSettings';
import { getRolesFromToken, getToken, removeToken, setToken } from './assets/js/tokenUtils';

Validator.extend('pesel', validatePesel);
Validator.extend('female', value => value === 'FEMALE');

Vue.component('vue-calendar', vueCalendar);
Vue.use(myConfig);
Vue.use(AsyncComputed);
Vue.use(VueCookie);
Vue.use(VueScrollTo);
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueTabs);
Vue.use(VueI18n);
Vue.use(VueMoment);
Vue.use(Vuetify);
Vue.use(vueVimeoPlayer);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCHEWfITZW3Xwl1Od0WjoYFd7dI4MbUFN8',
        libraries: 'places, visualization',
    },
});

var serverConfig = { myConfig };

export const config = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'fields',
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true,
    classes: false,
    classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'invalid', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty', // control has been interacted with
    },
    events: 'input|blur',
    inject: true,
    validity: true,
    aria: true,
    sessionDurationInSeconds: 1800,
    numbersOnlyRegex: /[^0-9]*$/,
    nameRegex: /^[a-zA-ZzżźćńółęąśŻŹĆĄŚĘŁÓŃàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžŰűŐőÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðАаБбВвГгҐґДдЕеЄєЖжЗзИиІіЇїЙйКкЛлМмНнОоПпРрСсТтУуФфХхЦцЧчШшЩщЬьЮюЯяАаБбВвГгДдЕеЖжЗзИиЙйКкЛлМмНнОоПпРрСсТтУуФфХхЦцЧчШшЩщъyьiЮюЯяЪ’_ ÁáÃãÂâÀàÇçÉéÊêÍíÓóÔôÕõÚúChchDjdjGuguLhlhNhnhQuquRrrrScscSçsçShshSsssTchtchXcxcXsxsZzzzАаБбВвГгДдЂђЕеЖжЗзИиJjКкЛлЉљМмНнЊњОоПпРрСсТтЋћУуФфХхЦцЧчЏџШшAaBbVvGgDdĐđEeŽžZzIiJjKkLlLjljMmNnNjnjOoPpRrSsTtĆćUuFfHhCcČčDždžŠš'-.]*$/,
    passwordRegex: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\x00-\x2F|\x3A-\x40|\x5B-\x60|\x7B-\x7F])[\x00-\x7F]{8,}$',
    emailRegex: /^(?=(((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{1,63}\.)+[a-zA-Z]{2,63})))))(.{1,250})$/,
    ...serverConfig.myConfig.data().myUrls,
};

Vue.use(VeeValidate, config);

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'active',
    routes,
});

setInterval(() => {
    if (store.state.isUserLogged) {
        const lastUserActionDate = Vue.cookie.get('lastUserActionDate');
        const diffMs = new Date().getTime() - lastUserActionDate;
        if (diffMs > config.sessionDurationInSeconds * 1000) {
            logoutUser();
        }
    }
}, 1000);

document.body.onmousedown = () => Vue.cookie.set('lastUserActionDate', new Date().getTime());

let popup = null;

export function seeTermogram(examinationId) {
    popup = window.open('', '', 'width=1100, height=600');
    const serverUrl = config.localUrl + '/braster-viewer/';
    const fileUrl = config.localUrl + '/examination/api/visualisation/preprocessed/' + examinationId;
    const postUrl = config.localUrl + '/examination/api/visualisation/uploadResult/' + examinationId;
    const documentUrl = config.localUrl + '/examination/api/visualisation/userData/' + examinationId;
    const amikUrl = config.localUrl + '/examination/api/visualisation/amik/' + examinationId;
    const roles_url = config.localUrl + '/user/api/doctor/user/roles';
    const permission_url = config.localUrl + '/user/api/doctor/priviligats';
    const user_url = config.localUrl + '/user/api/profile/user';
    const lang = store.state.interfaceLanguage;
    const product_line = 'PRO_BASIC';
    const url =
        `${serverUrl}?file=${fileUrl}&postUrl=${postUrl}&token=${
            getToken().access_token
        }&document_url=${documentUrl}&amik=${amikUrl}&roles_url=${roles_url}&permission_url=${permission_url}&lang=${lang}&user_url=${user_url}&readOnly=true&mkpro=true&product_line=` +
        product_line;

    popup.location.replace(url);
}

window.onmessage = event => {
    if (event.data === 'viewer-ready') {
        popup.postMessage({ id: 'token', token: getToken().access_token }, '*');
    }

    if (event.data === 'viewer-closed') {
        popup.close();
    }
};

let requestCounter = 0;
let isRefreshingToken = false;
let refreshTokenSubscribers = [];

Vue.http.interceptors.push((request, next) => {
    const token = getToken();
    if (token) {
        request.headers.set('Authorization', `Bearer ${token.access_token}`);
    }
    if (
        !request.url.includes(config.authUrl) &&
        !request.url.includes(config.localUrl) &&
        !request.url.includes(config.eSklepUrl)
    ) {
        request.url = `${config.localUrl}${request.url}`;
    }
    request.headers.set('Accept-Language', store.state.interfaceLanguage);
    requestCounter++;
    store.commit('setShowLoadingSpinner', requestCounter > 0);
    next(response => {
        requestCounter--;
        store.commit('setShowLoadingSpinner', requestCounter > 0);
        if (response.status === 401 && !response.url.includes(config.authUrl)) {
            const token = getToken();

            const refreshToken = () => {
                if (token) {
                    const params = {
                        client_id: config.client_id,
                        client_secret: config.client_secret,
                        grant_type: 'refresh_token',
                        refresh_token: token.refresh_token,
                    };
                    isRefreshingToken = true;
                    return Vue.http.post(`${config.authUrl}/oauth/token`, null, { params }).then(({ data }) => {
                        setToken(data);
                        isRefreshingToken = false;
                        refreshTokenSubscribers.map(cb => cb(data.access_token));
                        refreshTokenSubscribers = [];
                    });
                } else {
                    logoutUser();
                }
            };

            if (!isRefreshingToken) {
                refreshToken();
            }
            return new Promise(resolve => {
                refreshTokenSubscribers.push(accessToken => {
                    response.headers.set('Authorization', `Bearer ${accessToken}`);
                    resolve(Vue.http(response));
                });
            });
        }
    });
});

export function logoutUser() {
    removeToken();
    location.href = `${config.eSklepUrl}/pl/customer/account/LogoutMojeKonto?url=${window.location.host}/logowanie`;
}

export let eventBus;

export function init(lang) {
    console.log('lang2: ', lang);

    //Switch language
    switch (lang) {
        case 'pl':
            locale.use(require('element-ui/lib/locale/lang/pl').default);
            Vue.moment.locale('pl');
            Validator.localize('pl', require('vee-validate/dist/locale/pl'));
            break;
        case 'ru':
            locale.use(require('element-ui/lib/locale/lang/ru-RU').default);
            Vue.moment.locale('ru');
            Validator.localize('ru', require('vee-validate/dist/locale/ru'));
            break;
        case 'it':
            locale.use(require('element-ui/lib/locale/lang/it').default);
            Vue.moment.locale('it');
            Validator.localize('it', require('vee-validate/dist/locale/it'));
            break;
        case 'es':
            locale.use(require('element-ui/lib/locale/lang/es').default);
            Vue.moment.locale('es');
            Validator.localize('es', require('vee-validate/dist/locale/es'));
            break;
        case 'ar':
            locale.use(require('element-ui/lib/locale/lang/ar').default);
            Vue.moment.locale('ar');
            Validator.localize('ar', require('vee-validate/dist/locale/ar'));
            break;
        case 'hu':
            locale.use(require('element-ui/lib/locale/lang/hu').default);
            Vue.moment.locale('hu');
            Validator.localize('hu', require('vee-validate/dist/locale/hu'));
            break;
        case 'ko':
            locale.use(require('element-ui/lib/locale/lang/ko').default);
            Vue.moment.locale('ko');
            Validator.localize('ko', require('vee-validate/dist/locale/ko'));
            break;
        case 'uk':
            locale.use(require('element-ui/lib/locale/lang/ua').default);
            Vue.moment.locale('uk');
            Validator.localize('uk', require('vee-validate/dist/locale/uk'));
            break;
        case 'bg':
            locale.use(require('element-ui/lib/locale/lang/bg').default);
            Vue.moment.locale('bg');
            Validator.localize('bg', require('vee-validate/dist/locale/bg'));
            break;
        case 'pt':
            locale.use(require('element-ui/lib/locale/lang/pt').default);
            Vue.moment.locale('pt');
            Validator.localize('pt', require('vee-validate/dist/locale/pt_PT'));
            break;
        case 'sr':
            locale.use(require('element-ui/lib/locale/lang/sr').default);
            Vue.moment.locale('sr');
            Validator.localize('sr', require('vee-validate/dist/locale/sr'));
            break;
        case 'vn':
            locale.use(require('element-ui/lib/locale/lang/vi').default);
            Vue.moment.locale('vi');
            Validator.localize('vi', require('vee-validate/dist/locale/vi'));
            break;
        case 'mk':
            locale.use(require('element-ui/lib/locale/lang/en').default);
            Vue.moment.locale('mk');
            Validator.localize('mk', require('vee-validate/dist/locale/en'));
            break;
        case 'al':
            locale.use(require('element-ui/lib/locale/lang/en').default);
            Vue.moment.locale('sq');
            Validator.localize('sq', require('vee-validate/dist/locale/sq'));
            break;
        case 'br':
            locale.use(require('element-ui/lib/locale/lang/en').default);
            Vue.moment.locale('br');
            Validator.localize('br', require('vee-validate/dist/locale/sq'));
            break;
        default:
            lang = 'en';
            locale.use(require('element-ui/lib/locale/lang/en').default);
            Vue.moment.locale('en');
            Validator.localize('en', require('vee-validate/dist/locale/en'));
    }
    let i18n = new VueI18n({
        locale: lang,
        messages: dictionary,
    });
    Vue.cookie.set('interfaceLanguage', lang);
    store.commit('refreshInterfaceLanguage');
    eventBus = new Vue();
    new Vue({
        el: '#app',
        locale: lang,
        i18n,
        router,
        store,
        render: h => h(App),
    });
}

export function extendExaminationIsoDateInformation(examination) {
    examination.isoDate = mapDateToUserTimezone(examination.examinationDate);
    return examination;
}

export function loadUserData() {
    store.commit('RESET_SURVEY');
    store.dispatch('fetchUser').then(user => {
        if (getRolesFromToken().includes('ROLE_PATIENT')) {
            if (user.showInfo) {
                router.push('/account-info');
                init(user.interfaceLanguage.code);
            } else if (store.getters.accountTypeIsPro) {
                store.dispatch('fetchExaminations').then(() => init(user.interfaceLanguage.code));
            } else {
                Promise.all([
                    store.dispatch('fetchExaminations'),
                    store.dispatch('fetchUserSurvey'),
                    user.patient.ehrId && getComposition(),
                ]).then(() => init(user.interfaceLanguage.code));
            }
        } else {
            alert('Doctors cannot use MyAccount!');
            logoutUser();
        }
    });
}

function getComposition() {
    Vue.http.get('/openehr/api/composition/').then(response => {
        store.state.medicalData = response.data;
        mapFromMedicalData();
    });
}

export function mapUserSurveyData() {
    const section4 = store.getters.survey.section4;
    return {
        breastSize: section4.q1,
        hasMenstruation: section4.q2 !== 'DO_NOT_MENSTRUATE',
        regularityOfMenstruation: section4.q2 === 'YES' ? true : section4.q2 === 'NO' ? false : null,
        menstruationDuration: section4.q2 === 'YES' ? section4.q2_1 : '',
        dateOfLastMenstruation: section4.q2 !== 'DO_NOT_MENSTRUATE' ? section4.lastPeriod : '',
    };
}

export function mapMedicalData() {
    var medicalData = store.state.medicalData;

    var height = store.state.survey.survey.section3.user_height;
    var weight = store.state.survey.survey.section3.user_weight;

    medicalData.fields[0].value = height;
    medicalData.fields[1].value = weight;
    medicalData.fields[2].value = ((weight * 10000) / (height * height)).toFixed(2);
    medicalData.fields[3].value = medicalData.fields[2].value; //Szybki fix, nie wiemy czemu w trzecim polu wysylana jest jakakolwiek wartosc

    if (store.state.survey.survey.section4.q1 == '1') {
        medicalData.questions[0].value = 'at0005';
    } else if (store.state.survey.survey.section4.q1 == '2') {
        medicalData.questions[0].value = 'at0006';
    } else if (store.state.survey.survey.section4.q1 == '3') {
        medicalData.questions[0].value = 'at0007';
    } else if (store.state.survey.survey.section4.q1 == '4') {
        medicalData.questions[0].value = 'at0008';
    } else if (store.state.survey.survey.section4.q1 == '5') {
        medicalData.questions[0].value = 'at0009';
    }

    if (store.state.survey.survey.section3.q2_1 == 'YES' && store.state.survey.survey.section3.q2_2 == 'NO') {
        medicalData.questions[1].value = 'at0058';
    } else if (store.state.survey.survey.section3.q2_2 == 'YES' && store.state.survey.survey.section3.q2_1 == 'NO') {
        medicalData.questions[1].value = 'at0057';
    } else if (store.state.survey.survey.section3.q2_1 == 'YES' && store.state.survey.survey.section3.q2_2 == 'YES') {
        medicalData.questions[1].value = 'at0059';
    } else if (store.state.survey.survey.section3.q2_1 == 'NO' && store.state.survey.survey.section3.q2_2 == 'NO') {
        medicalData.questions[1].value = 'at0053';
    }

    if (store.state.survey.survey.section3.q2_1 == 'NO') {
        store.state.survey.survey.section3.q2_1_size = '';
        store.state.survey.survey.section3.q2_1_location = {};
        store.state.survey.survey.section3.q2_1_location.x = -9999;
        store.state.survey.survey.section3.q2_1_location.y = -9999;
    }

    if (store.state.survey.survey.section3.q2_2 == 'NO') {
        store.state.survey.survey.section3.q2_2_size = '';
        store.state.survey.survey.section3.q2_2_location = {};
        store.state.survey.survey.section3.q2_2_location.x = -9999;
        store.state.survey.survey.section3.q2_2_location.y = -9999;
    }

    medicalData.questions[1].subquestions[0].cancerValue.description.value =
        store.state.survey.survey.section3.q2_1_size + '|||' + store.state.survey.survey.section3.q2_2_size;

    if (
        store.state.survey.survey.section3.q2_1_location != null &&
        store.state.survey.survey.section3.q2_1_size != null
    ) {
        medicalData.questions[1].subquestions[0].cancerValue.breast.rightX =
            store.state.survey.survey.section3.q2_1_location.x;
        medicalData.questions[1].subquestions[0].cancerValue.breast.rightY =
            store.state.survey.survey.section3.q2_1_location.y;
    }

    if (
        store.state.survey.survey.section3.q2_2_location != null &&
        store.state.survey.survey.section3.q2_2_size != null
    ) {
        medicalData.questions[1].subquestions[0].cancerValue.breast.leftX =
            store.state.survey.survey.section3.q2_2_location.x;
        medicalData.questions[1].subquestions[0].cancerValue.breast.leftY =
            store.state.survey.survey.section3.q2_2_location.y;
    }

    if (store.state.survey.survey.section3.q3 == 'YES') {
        medicalData.questions[2].value = 'at0006';
    } else if (store.state.survey.survey.section3.q3 == 'NO') {
        medicalData.questions[2].value = 'at0005';
    } else if (store.state.survey.survey.section3.q3 == 'YES_BUT_STOPPED_MORE_THAN_TEN_YEARS') {
        medicalData.questions[2].value = 'at0007';
    } else if (store.state.survey.survey.section3.q3 == 'YES_BUT_STOPPED_LESS_THAN_TEN_YEARS') {
        medicalData.questions[2].value = 'at0008';
    }

    if (store.state.survey.survey.section3.q4 == 'NO') {
        medicalData.questions[3].value = 'at0011';
    } else if (store.state.survey.survey.section3.q4 == 'YES_BUT_LESS_THAN_FIVE_YEARS') {
        medicalData.questions[3].value = 'at0012';
    } else if (store.state.survey.survey.section3.q4 == 'YES_BUT_MORE_THAN_FIVE_YEARS') {
        medicalData.questions[3].value = 'at0013';
    }

    if (store.state.survey.survey.section3.q5_before == 'YES') {
        medicalData.questions[4].value = 'at0018';
    } else if (store.state.survey.survey.section3.q5_before == 'NO') {
        medicalData.questions[4].value = 'at0017';
    } else if (store.state.survey.survey.section3.q5_before == 'I_DO_NOT_KNOW') {
        medicalData.questions[4].value = 'at0019';
    }

    if (store.state.survey.survey.section3.q5_after == 'YES') {
        medicalData.questions[5].value = 'at0021';
    } else if (store.state.survey.survey.section3.q5_after == 'NO') {
        medicalData.questions[5].value = 'at0020';
    } else if (store.state.survey.survey.section3.q5_after == 'I_DO_NOT_KNOW') {
        medicalData.questions[5].value = 'at0022';
    }

    if (store.state.survey.survey.section3.q6 == 'DID_NOT_CHECK') {
        medicalData.questions[6].value = 'at0023';
    } else if (store.state.survey.survey.section3.q6 == 'NO') {
        medicalData.questions[6].value = 'at0025';
    } else if (store.state.survey.survey.section3.q6 == 'YES') {
        medicalData.questions[6].value = 'at0024';
    }

    if (store.state.survey.survey.section3.q7 == 'YES_LEFT') {
        medicalData.questions[18].value = 'at0077';
    } else if (store.state.survey.survey.section3.q7 == 'YES_RIGHT') {
        medicalData.questions[18].value = 'at0078';
    } else if (store.state.survey.survey.section3.q7 == 'YES_BOTH') {
        medicalData.questions[18].value = 'at0079';
    } else if (store.state.survey.survey.section3.q7 == 'NO') {
        medicalData.questions[18].value = 'at0080';
    }

    if (store.state.survey.survey.section3.q7 == 'NO') {
        store.state.survey.survey.section3.q7_type = '';
        store.state.survey.survey.section3.q7_description = '';
    }

    if (store.state.survey.survey.section3.q7_type) {
        medicalData.questions[18].subquestions[0].value = store.state.survey.survey.section3.q7_type;
    }
    if (store.state.survey.survey.section3.q7_description) {
        medicalData.questions[18].subquestions[1].value = store.state.survey.survey.section3.q7_description;
    }

    medicalData.questions[7].value = 'at0047';
    medicalData.questions[9].value = 'at0051';
    medicalData.questions[10].value = '';

    if (store.state.survey.survey.section2.q1 == 'NO') {
        medicalData.questions[11].value = 'at0027';
    } else if (store.state.survey.survey.section2.q1 == 'YES') {
        medicalData.questions[11].value = 'at0028';
    }

    if (store.state.survey.survey.section2.q2 == 'NO') {
        medicalData.questions[12].value = 'at0030';
    } else if (store.state.survey.survey.section2.q2 == 'YES') {
        medicalData.questions[12].value = 'at0031';
    }

    if (store.state.survey.survey.section2.q3 == 'NO') {
        medicalData.questions[8].value = 'at0049';
    } else if (store.state.survey.survey.section2.q3 == 'YES') {
        medicalData.questions[8].value = 'at0048';
    }

    if (store.state.survey.survey.section2.q4 == 'YES') {
        medicalData.questions[14].value = 'at0056';
    } else if (store.state.survey.survey.section2.q4 == 'NO') {
        medicalData.questions[14].value = 'at0058';
    }

    if (store.state.survey.survey.section3.q8_1 == 'YES') {
        medicalData.questions[16].value = 'at0067';
    } else if (store.state.survey.survey.section3.q8_1 == 'NO') {
        medicalData.questions[16].value = 'at0068';
    }

    if (store.state.survey.survey.section3.q8_1 == 'NO') {
        store.state.survey.survey.section3.q8_1_type = '';
    }

    if (store.state.survey.survey.section3.q8_1_type) {
        medicalData.questions[16].subquestions[0].value = store.state.survey.survey.section3.q8_1_type;
    }

    if (store.state.survey.survey.section3.q8_2 == 'YES') {
        medicalData.questions[15].value = 'at0065';
    } else if (store.state.survey.survey.section3.q8_2 == 'NO') {
        medicalData.questions[15].value = 'at0066';
    }

    if (store.state.survey.survey.section3.q8_2 == 'NO') {
        store.state.survey.survey.section3.q8_2_type = '';
    }

    if (store.state.survey.survey.section3.q8_2_type) {
        medicalData.questions[15].subquestions[0].value = store.state.survey.survey.section3.q8_2_type;
    }

    if (store.state.survey.survey.section4.q3 == 'YES') {
        medicalData.questions[17].value = 'at0070';
    } else if (store.state.survey.survey.section4.q3 == 'NO') {
        medicalData.questions[17].value = 'at0071';
    }

    if (store.state.survey.survey.section4.q4 == 'GLANDULAR_OR_ADIPOSE_FAT') {
        medicalData.questions[13].value = 'at0033';
    } else if (store.state.survey.survey.section4.q4 == 'FATTY_OR_FATTY_GLANDULAR') {
        medicalData.questions[13].value = 'at0034';
    } else if (store.state.survey.survey.section4.q4 == 'I_DO_NOT_KNOW') {
        medicalData.questions[13].value = 'at0081';
    }

    medicalData.additional_data[0].values = [];
    medicalData.additional_data[1].values = [];
    medicalData.additional_data[2].values = [];
    medicalData.additional_data[3].values = [];

    if (store.state.survey.survey.additionalData != null) {
        for (var row = 0; row < store.state.survey.survey.additionalData.length; row++) {
            medicalData.additional_data[0].values.push();
            medicalData.additional_data[1].values.push();
            medicalData.additional_data[2].values.push();
            medicalData.additional_data[3].values.push();

            if (store.state.survey.survey.additionalData[row].type == '0') {
                medicalData.additional_data[0].values[row] = 'at0040';
            } else if (store.state.survey.survey.additionalData[row].type == '1') {
                medicalData.additional_data[0].values[row] = 'at0041';
            } else if (store.state.survey.survey.additionalData[row].type == '2') {
                medicalData.additional_data[0].values[row] = 'at0042';
            } else if (store.state.survey.survey.additionalData[row].type == '3') {
                medicalData.additional_data[0].values[row] = 'at0043';
            } else if (store.state.survey.survey.additionalData[row].type == '4') {
                medicalData.additional_data[0].values[row] = 'at0044';
            } else if (store.state.survey.survey.additionalData[row].type == '4a') {
                medicalData.additional_data[0].values[row] = 'at0045';
            } else if (store.state.survey.survey.additionalData[row].type == '4b') {
                medicalData.additional_data[0].values[row] = 'at0046';
            } else if (store.state.survey.survey.additionalData[row].type == '4c') {
                medicalData.additional_data[0].values[row] = 'at0047';
            } else if (store.state.survey.survey.additionalData[row].type == '5') {
                medicalData.additional_data[0].values[row] = 'at0048';
            } else if (store.state.survey.survey.additionalData[row].type == '6') {
                medicalData.additional_data[0].values[row] = 'at0049';
            } else if (store.state.survey.survey.additionalData[row].type == 'NONE') {
                medicalData.additional_data[0].values[row] = 'at0050';
            }

            if (store.state.survey.survey.additionalData[row].name == 'USG') {
                medicalData.additional_data[1].values[row] = 'at0051';
            } else if (store.state.survey.survey.additionalData[row].name == 'MAMMOGRAPHY') {
                medicalData.additional_data[1].values[row] = 'at0052';
            } else if (store.state.survey.survey.additionalData[row].name == 'MRI') {
                medicalData.additional_data[1].values[row] = 'at0053';
            } else if (store.state.survey.survey.additionalData[row].name == 'ELASTOGRAPHY') {
                medicalData.additional_data[1].values[row] = 'at0054';
            }

            medicalData.additional_data[2].values[row] = store.state.survey.survey.additionalData[row].description;
            medicalData.additional_data[3].values[row] = store.state.survey.survey.additionalData[row].date;
        }
    }

    if (store.state.survey.survey.section3.q2_2_observe == 'YES') {
        medicalData.questions[19].value = 'at0087';
    } else if (store.state.survey.survey.section3.q2_2_observe == 'NO') {
        medicalData.questions[19].value = 'at0086';
    }

    if (store.state.survey.survey.section3.q2_2_observe == 'NO') {
        store.state.survey.survey.section3.q2_2_type_observe = [];
        store.state.survey.survey.section3.q2_2_type_observe_custom = '';
    }

    if (store.state.survey.survey.section3.q2_2_type_observe) {
        medicalData.questions[19].subquestions[0].value = store.state.survey.survey.section3.q2_2_type_observe.join(
            '|||',
        );
    }

    if (store.state.survey.survey.section3.q2_2_type_observe_custom) {
        medicalData.questions[19].subquestions[1].value = store.state.survey.survey.section3.q2_2_type_observe_custom;
    }

    if (store.state.survey.survey.section3.q2_1_observe == 'YES') {
        medicalData.questions[20].value = 'at0089';
    } else if (store.state.survey.survey.section3.q2_1_observe == 'NO') {
        medicalData.questions[20].value = 'at0088';
    }

    if (store.state.survey.survey.section3.q2_1_observe == 'NO') {
        store.state.survey.survey.section3.q2_1_type_observe = [];
        store.state.survey.survey.section3.q2_1_type_observe_custom = '';
    }

    if (store.state.survey.survey.section3.q2_1_type_observe) {
        medicalData.questions[20].subquestions[0].value = store.state.survey.survey.section3.q2_1_type_observe.join(
            '|||',
        );
    }

    if (store.state.survey.survey.section3.q2_1_type_observe_custom) {
        medicalData.questions[20].subquestions[1].value = store.state.survey.survey.section3.q2_1_type_observe_custom;
    }

    if (store.state.survey.survey.section3.q10 == 'YES') {
        medicalData.questions[21].value = 'at0095';
        if (store.state.survey.survey.section3.q10_type == 'SILICON') {
            medicalData.questions[21].subquestions[0].value = 'at0097';
        } else if (store.state.survey.survey.section3.q10_type == 'SALINE') {
            medicalData.questions[21].subquestions[0].value = 'at0098';
        }
        if (store.state.survey.survey.section3.q10_location == 'GLAND') {
            medicalData.questions[21].subquestions[1].value = 'at0100';
        } else if (store.state.survey.survey.section3.q10_location == 'MUSCLE') {
            medicalData.questions[21].subquestions[1].value = 'at0101';
        }
    } else if (store.state.survey.survey.section3.q10 == 'NO') {
        medicalData.questions[21].value = 'at0096';
        medicalData.questions[21].subquestions[0].value = 'at0099';
        medicalData.questions[21].subquestions[1].value = 'at0102';
    }
}

export function mapFromMedicalData() {
    var medicalData = store.state.medicalData;

    store.state.survey.survey.section3.user_height = medicalData.fields[0].value;
    store.state.survey.survey.section3.user_weight = medicalData.fields[1].value;

    if (medicalData.questions[0].value == 'at0005') {
        store.state.survey.survey.section4.q1 = '1';
    } else if (medicalData.questions[0].value == 'at0006') {
        store.state.survey.survey.section4.q1 = '2';
    } else if (medicalData.questions[0].value == 'at0007') {
        store.state.survey.survey.section4.q1 = '3';
    } else if (medicalData.questions[0].value == 'at0008') {
        store.state.survey.survey.section4.q1 = '4';
    } else if (medicalData.questions[0].value == 'at0009') {
        store.state.survey.survey.section4.q1 = '5';
    }

    if (medicalData.questions[1].value == 'at0057') {
        store.state.survey.survey.section3.q2_1 = 'NO';
        store.state.survey.survey.section3.q2_2 = 'YES';
    } else if (medicalData.questions[1].value == 'at0058') {
        store.state.survey.survey.section3.q2_1 = 'YES';
        store.state.survey.survey.section3.q2_2 = 'NO';
    } else if (medicalData.questions[1].value == 'at0059') {
        store.state.survey.survey.section3.q2_1 = 'YES';
        store.state.survey.survey.section3.q2_2 = 'YES';
    } else if (medicalData.questions[1].value == 'at0053') {
        store.state.survey.survey.section3.q2_1 = 'NO';
        store.state.survey.survey.section3.q2_2 = 'NO';
    }

    if (medicalData.questions[1].subquestions[0].cancerValue.description.value) {
        store.state.survey.survey.section3.q2_1_size = medicalData.questions[1].subquestions[0].cancerValue.description.value.split(
            '|||',
        )[0];
        store.state.survey.survey.section3.q2_2_size = medicalData.questions[1].subquestions[0].cancerValue.description.value.split(
            '|||',
        )[1];
    }

    if (!store.state.survey.survey.section3.q2_1_size) {
        store.state.survey.survey.section3.q2_1_size = '';
    }

    if (!store.state.survey.survey.section3.q2_2_size) {
        store.state.survey.survey.section3.q2_2_size = '';
    }

    if (
        store.state.survey.survey.accountStage == 'MEDICAL_DATA_SET' ||
        store.state.survey.survey.accountStage == 'DISALLOWED_AFTER_SURVEY'
    ) {
        store.state.survey.survey.section3.q2_1_location = {};
        store.state.survey.survey.section3.q2_2_location = {};
        store.state.survey.survey.section3.q2_2_location.x =
            medicalData.questions[1].subquestions[0].cancerValue.breast.leftX;
        store.state.survey.survey.section3.q2_2_location.y =
            medicalData.questions[1].subquestions[0].cancerValue.breast.leftY;
        store.state.survey.survey.section3.q2_1_location.x =
            medicalData.questions[1].subquestions[0].cancerValue.breast.rightX;
        store.state.survey.survey.section3.q2_1_location.y =
            medicalData.questions[1].subquestions[0].cancerValue.breast.rightY;
    }

    if (medicalData.questions[2].value == 'at0006') {
        store.state.survey.survey.section3.q3 = 'YES';
    } else if (medicalData.questions[2].value == 'at0005') {
        store.state.survey.survey.section3.q3 = 'NO';
    } else if (medicalData.questions[2].value == 'at0007') {
        store.state.survey.survey.section3.q3 = 'YES_BUT_STOPPED_MORE_THAN_TEN_YEARS';
    } else if (medicalData.questions[2].value == 'at0008') {
        store.state.survey.survey.section3.q3 = 'YES_BUT_STOPPED_LESS_THAN_TEN_YEARS';
    }

    if (medicalData.questions[3].value == 'at0011') {
        store.state.survey.survey.section3.q4 = 'NO';
    } else if (medicalData.questions[3].value == 'at0012') {
        store.state.survey.survey.section3.q4 = 'YES_BUT_LESS_THAN_FIVE_YEARS';
    } else if (medicalData.questions[3].value == 'at0013') {
        store.state.survey.survey.section3.q4 = 'YES_BUT_MORE_THAN_FIVE_YEARS';
    }

    if (medicalData.questions[4].value == 'at0018') {
        store.state.survey.survey.section3.q5_before = 'YES';
    } else if (medicalData.questions[4].value == 'at0017') {
        store.state.survey.survey.section3.q5_before = 'NO';
    } else if (medicalData.questions[4].value == 'at0019') {
        store.state.survey.survey.section3.q5_before = 'I_DO_NOT_KNOW';
    }

    if (medicalData.questions[5].value == 'at0021') {
        store.state.survey.survey.section3.q5_after = 'YES';
    } else if (medicalData.questions[5].value == 'at0020') {
        store.state.survey.survey.section3.q5_after = 'NO';
    } else if (medicalData.questions[5].value == 'at0022') {
        store.state.survey.survey.section3.q5_after = 'I_DO_NOT_KNOW';
    }

    if (medicalData.questions[6].value == 'at0023') {
        store.state.survey.survey.section3.q6 = 'DID_NOT_CHECK';
    } else if (medicalData.questions[6].value == 'at0025') {
        store.state.survey.survey.section3.q6 = 'NO';
    } else if (medicalData.questions[6].value == 'at0024') {
        store.state.survey.survey.section3.q6 = 'YES';
    }

    if (medicalData.questions[18].value == 'at0077') {
        store.state.survey.survey.section3.q7 = 'YES_LEFT';
    } else if (medicalData.questions[18].value == 'at0078') {
        store.state.survey.survey.section3.q7 = 'YES_RIGHT';
    } else if (medicalData.questions[18].value == 'at0079') {
        store.state.survey.survey.section3.q7 = 'YES_BOTH';
    } else if (medicalData.questions[18].value == 'at0080') {
        store.state.survey.survey.section3.q7 = 'NO';
    }

    if (!Array.isArray(medicalData.questions[18].subquestions[0].value)) {
        store.state.survey.survey.section3.q7_type = medicalData.questions[18].subquestions[0].value;
    }

    if (!Array.isArray(medicalData.questions[18].subquestions[1].value)) {
        store.state.survey.survey.section3.q7_description = medicalData.questions[18].subquestions[1].value;
    }

    if (medicalData.questions[11].value == 'at0027') {
        store.state.survey.survey.section2.q1 = 'NO';
        store.state.survey.survey.section2.disallow_by_pregnant = false;
    } else if (medicalData.questions[11].value == 'at0028') {
        store.state.survey.survey.section2.q1 = 'YES';
        store.state.survey.survey.section2.disallow_by_pregnant = true;
    }

    if (medicalData.questions[12].value == 'at0030') {
        store.state.survey.survey.section2.q2 = 'NO';
        store.state.survey.survey.section2.disallow_by_breast_cancer = false;
    } else if (medicalData.questions[12].value == 'at0031') {
        store.state.survey.survey.section2.q2 = 'YES';
        store.state.survey.survey.section2.disallow_by_breast_cancer = true;
    }

    if (medicalData.questions[8].value == 'at0049') {
        store.state.survey.survey.section2.q3 = 'NO';
        store.state.survey.survey.section2.disallow_by_breast_surgery = false;
    } else if (medicalData.questions[8].value == 'at0048') {
        store.state.survey.survey.section2.q3 = 'YES';
        store.state.survey.survey.section2.disallow_by_breast_surgery = true;
    }

    if (medicalData.questions[14].value == 'at0056') {
        store.state.survey.survey.section2.q4 = 'YES';
        store.state.survey.survey.section2.disallow_by_breast_enlargement = true;
    } else if (medicalData.questions[14].value == 'at0058') {
        store.state.survey.survey.section2.q4 = 'NO';
        store.state.survey.survey.section2.disallow_by_breast_enlargement = false;
    }

    if (medicalData.questions[16].value == 'at0067') {
        store.state.survey.survey.section3.q8_1 = 'YES';
    } else if (medicalData.questions[16].value == 'at0068') {
        store.state.survey.survey.section3.q8_1 = 'NO';
    }

    if (!Array.isArray(medicalData.questions[16].subquestions[0].value)) {
        store.state.survey.survey.section3.q8_1_type = medicalData.questions[16].subquestions[0].value;
    }

    if (medicalData.questions[15].value == 'at0065') {
        store.state.survey.survey.section3.q8_2 = 'YES';
    } else if (medicalData.questions[15].value == 'at0066') {
        store.state.survey.survey.section3.q8_2 = 'NO';
    }

    if (!Array.isArray(medicalData.questions[15].subquestions[0].value)) {
        store.state.survey.survey.section3.q8_2_type = medicalData.questions[15].subquestions[0].value;
    }

    store.dispatch('fetchUserSurvey').then(data => {
        const section4 = store.state.survey.survey.section4;
        section4.q1 = data.breastSize;
        section4.q2 =
            data.regularityOfMenstruation === true
                ? 'YES'
                : data.regularityOfMenstruation === false
                ? 'NO'
                : 'DO_NOT_MENSTRUATE';
        section4.q2_1 = data.regularityOfMenstruation === true ? data.menstruationDuration : '';
        section4.lastPeriod = data.regularityOfMenstruation != null ? data.dateOfLastMenstruation : '';
    });

    if (medicalData.questions[17].value == 'at0070') {
        store.state.survey.survey.section4.q3 = 'YES';
    } else if (medicalData.questions[17].value == 'at0071') {
        store.state.survey.survey.section4.q3 = 'NO';
    }

    if (medicalData.questions[13].value == 'at0033') {
        store.state.survey.survey.section4.q4 = 'GLANDULAR_OR_ADIPOSE_FAT';
    } else if (medicalData.questions[13].value == 'at0034') {
        store.state.survey.survey.section4.q4 = 'FATTY_OR_FATTY_GLANDULAR';
    } else if (medicalData.questions[13].value == 'at0081') {
        store.state.survey.survey.section4.q4 = 'I_DO_NOT_KNOW';
    }

    store.state.survey.survey.additionalData = [];

    for (var row = 0; row < medicalData.additional_data[1].values.length; row++) {
        store.state.survey.survey.additionalData.push({});

        if (medicalData.additional_data[0].values[row] == 'at0040') {
            store.state.survey.survey.additionalData[row].type = '0';
        } else if (medicalData.additional_data[0].values[row] == 'at0041') {
            store.state.survey.survey.additionalData[row].type = '1';
        } else if (medicalData.additional_data[0].values[row] == 'at0042') {
            store.state.survey.survey.additionalData[row].type = '2';
        } else if (medicalData.additional_data[0].values[row] == 'at0043') {
            store.state.survey.survey.additionalData[row].type = '3';
        } else if (medicalData.additional_data[0].values[row] == 'at0044') {
            store.state.survey.survey.additionalData[row].type = '4';
        } else if (medicalData.additional_data[0].values[row] == 'at0045') {
            store.state.survey.survey.additionalData[row].type = '4a';
        } else if (medicalData.additional_data[0].values[row] == 'at0046') {
            store.state.survey.survey.additionalData[row].type = '4b';
        } else if (medicalData.additional_data[0].values[row] == 'at0047') {
            store.state.survey.survey.additionalData[row].type = '4c';
        } else if (medicalData.additional_data[0].values[row] == 'at0048') {
            store.state.survey.survey.additionalData[row].type = '5';
        } else if (medicalData.additional_data[0].values[row] == 'at0049') {
            store.state.survey.survey.additionalData[row].type = '6';
        } else if (medicalData.additional_data[0].values[row] == 'at0050') {
            store.state.survey.survey.additionalData[row].type = 'NONE';
        }

        if (medicalData.additional_data[1].values[row] == 'at0051') {
            store.state.survey.survey.additionalData[row].name = 'USG';
        } else if (medicalData.additional_data[1].values[row] == 'at0052') {
            store.state.survey.survey.additionalData[row].name = 'MAMMOGRAPHY';
        } else if (medicalData.additional_data[1].values[row] == 'at0053') {
            store.state.survey.survey.additionalData[row].name = 'MRI';
        } else if (medicalData.additional_data[1].values[row] == 'at0054') {
            store.state.survey.survey.additionalData[row].name = 'ELASTOGRAPHY';
        }

        store.state.survey.survey.additionalData[row].description = medicalData.additional_data[2].values[row];
        store.state.survey.survey.additionalData[row].date = medicalData.additional_data[3].values[row];
    }

    if (medicalData.questions[19].value == 'at0087') {
        store.state.survey.survey.section3.q2_2_observe = 'YES';
    } else if (medicalData.questions[19].value == 'at0086') {
        store.state.survey.survey.section3.q2_2_observe = 'NO';
    }

    if (!Array.isArray(medicalData.questions[19].subquestions[0].value)) {
        store.state.survey.survey.section3.q2_2_type_observe = medicalData.questions[19].subquestions[0].value.split(
            '|||',
        );
        store.state.survey.survey.section3.q2_2_type_observe_custom = medicalData.questions[19].subquestions[1].value;
    }

    if (medicalData.questions[20].value == 'at0089') {
        store.state.survey.survey.section3.q2_1_observe = 'YES';
    } else if (medicalData.questions[20].value == 'at0088') {
        store.state.survey.survey.section3.q2_1_observe = 'NO';
    }

    if (!Array.isArray(medicalData.questions[20].subquestions[0].value)) {
        store.state.survey.survey.section3.q2_1_type_observe = medicalData.questions[20].subquestions[0].value.split(
            '|||',
        );
        store.state.survey.survey.section3.q2_1_type_observe_custom = medicalData.questions[20].subquestions[1].value;
    }

    if (medicalData.questions[21].value == 'at0095') {
        store.state.survey.survey.section3.q10 = 'YES';
        if (medicalData.questions[21].subquestions[0].value == 'at0097') {
            store.state.survey.survey.section3.q10_type = 'SILICON';
        } else if (medicalData.questions[21].subquestions[0].value == 'at0098') {
            store.state.survey.survey.section3.q10_type = 'SALINE';
        }
        if (medicalData.questions[21].subquestions[1].value == 'at0100') {
            store.state.survey.survey.section3.q10_location = 'GLAND';
        } else if (medicalData.questions[21].subquestions[1].value == 'at0101') {
            store.state.survey.survey.section3.q10_location = 'MUSCLE';
        }
    } else if (medicalData.questions[21].value == 'at0096') {
        store.state.survey.survey.section3.q10 = 'NO';
        store.state.survey.survey.section3.q10_type = 'NO';
        store.state.survey.survey.section3.q10_location = 'NO';
    }
}

export function linkClicked(link) {
    window.open(link, '_blank').focus();
}

export function mapDateToUserTimezone(date) {
    // http://jsfiddle.net/jlubean/dL5cLjxt/
    const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // iOS does this conversion automatically, on other devices conversion needs to be done manually
    if (!isSafari && !iOS) {
        date = new Date(date);
        // Convert UTC time to client timezone time
        date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    }

    return date;
}

if (store.state.isUserLogged) {
    loadUserData();
} else {
    const urlLang = getParameterByName('interfaceLanguage');
    init(urlLang ? urlLang : store.state.interfaceLanguage);
    const to = router.resolve(location).resolved;
    if (to.meta.authenticationRequired) {
        Vue.cookie.set('redirectUrlAfterLogin', to.fullPath);
        router.push('/logowanie');
    }
}

router.beforeEach((to, from, next) => {
    if (to.meta.authenticationRequired && !store.state.isUserLogged) {
        next({
            name: 'logowanie',
        });
    } else if (to.name === 'logowanie' && store.state.isUserLogged) {
        next({
            name: 'moje-konto',
        });
    } else if (to.name === 'moje-dane' && store.getters.accountTypeIsPro) {
        next({
            name: 'moje-konto',
        });
    } else {
        next();
    }
});



// WEBPACK FOOTER //
// ./src/main.js